
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetoshirdiinnovacrystacarrental() {



    const cardData =
    {
        keyword: 'Pune to Shirdi Innova Crysta Car Rental',
        heading: 'Meghana Cab : Pune to Shirdi Innova Crysta Car Rental',
        headingDescription: 'Meghana Cab offers Pune to Shirdi Innova Crysta Car Rental, perfect for devotees and travelers seeking a comfortable and dignified journey to the sacred town. Our Innova Crysta vehicles feature plush leather interiors, spacious seating, and generous luggage space—ideal for families, groups, and long-distance travel. Whether you are heading to Shirdi for a day darshan or a weekend stay, enjoy a smooth ride with seasoned drivers who are well-versed with the route and local insights. Benefit from transparent fixed pricing (one-way or round-trip), door-to-door pickup from anywhere in Pune, GPS tracking, and 24/7 customer support. Book your Pune to Shirdi Innova Crysta Car Rental with Meghana Cab and travel with comfort, confidence, and complete peace of mind.',


        top: 'Top Places to Visit in Shirdi with Meghana Cab',

"topPlaces": [
  {
    "title": "Sai Baba Samadhi Mandir",
    "description": "The Sai Baba Samadhi Mandir is the heart of Shirdi and the most visited spiritual site in the town. Constructed in 1922 using white marble, it houses the final resting place and a life-size idol of Shri Sai Baba in a seated posture. Devotees from across the globe visit the temple for darshan, especially during Kakad Aarti, Madhyan Aarti, and Shej Aarti. The temple complex is efficiently managed with queues, online bookings, prasadalaya, and lodging facilities. Its sanctity, calm aura, and deeply spiritual vibe make it the primary reason pilgrims travel to Shirdi."
  },
  {
    "title": "Dwarkamai Mosque",
    "description": "Dwarkamai is a sacred site where Sai Baba spent a significant part of his life. Located adjacent to the Samadhi Mandir, it was a dilapidated mosque that Sai Baba transformed into a spiritual haven. Inside, one can find Sai Baba's stone seat, oil lamps, the sacred dhuni (holy fire) that still burns, and a palkhi (palanquin) used during processions. It is the only mosque in the world where a temple and fire altar co-exist, symbolizing Baba’s message of communal harmony and universal faith."
  },
  {
    "title": "Chavadi",
    "description": "Chavadi holds immense spiritual importance as it was the place where Sai Baba used to sleep every alternate night during the latter part of his life. Located near Dwarkamai, this modest structure is now preserved with care. Inside, visitors can see Baba’s wooden seat, water pot, and a silver palanquin. Every Thursday, a ceremonial procession known as the Palkhi procession is carried out with Sai Baba’s photo and belongings, attracting thousands of devotees who walk chanting bhajans and prayers."
  },
  {
    "title": "Gurusthan",
    "description": "Gurusthan, meaning 'place of the Guru', is believed to be the spot where Sai Baba first appeared as a young ascetic at the age of 16 under a neem tree. Today, the site houses a marble idol of Sai Baba, a sacred neem tree, a shivling, and a holy fire lamp that is kept burning continuously. Devotees believe that lighting incense sticks here grants wishes. The peaceful surroundings and spiritual energy make it a must-visit spot for those tracing Baba’s life journey."
  },
  {
    "title": "Sai Heritage Village",
    "description": "Located a few kilometers from the main temple complex, Sai Heritage Village is a unique theme park and museum that depicts key events from Sai Baba’s life using life-size statues and rural backdrops. It recreates scenes such as Baba helping the poor, healing devotees, and interacting with villagers. With bullock carts, village games, and traditional food stalls, it offers a mix of education and entertainment—perfect for families and children looking to learn about Baba’s life in an engaging way."
  },
  {
    "title": "Khandoba Temple",
    "description": "Situated at the entry point of Shirdi village, Khandoba Temple holds significance as the location where Mhalsapati, the temple priest, first addressed the young ascetic as “Sai.” This moment is considered the beginning of Baba’s recognition by the locals. The temple is dedicated to Lord Khandoba (a form of Shiva) and features two shrines, one for Khandoba and one for Sai Baba. The place holds both religious and historical importance and is often visited before entering the main temple."
  },
  {
    "title": "Lendi Baug",
    "description": "Lendi Baug is a serene garden that Sai Baba used to visit every morning and evening for meditation and rest. Located within walking distance from Dwarkamai, the garden features the Nanda Deep, a perpetually burning lamp placed by Baba under a neem tree. There is also a marble platform, water channels, and a small meditation area surrounded by greenery. It’s an ideal spot for devotees seeking a quiet moment of reflection in the lap of nature."
  },
  {
    "title": "Shri Saibaba Sansthan Prasadalaya",
    "description": "Operated by the Shri Saibaba Sansthan Trust, the Prasadalaya is one of the largest spiritual community kitchens in India, serving simple, nutritious vegetarian meals to thousands of devotees every day. The dining halls are spacious, clean, and run efficiently. For many visitors, having a meal here is a spiritual ritual in itself. With subsidized rates and a charitable spirit, the prasadalaya reflects Sai Baba's teaching of service and equality."
  },
  {
    "title": "Sai Baba Wax Museum",
    "description": "The Sai Baba Wax Museum in Shirdi offers lifelike wax figures of Sai Baba and other spiritual leaders, freedom fighters, and celebrities. It is a popular attraction for tourists, especially families with children. The museum provides a creative and modern way to engage with Sai Baba’s teachings, and also includes souvenir shops and selfie zones. It serves as a light-hearted break from the otherwise devotional journey."
  },
  {
    "title": "Wet n Joy Water Park (Near Shirdi)",
    "description": "Located just a few kilometers from the temple, Wet n Joy Water Park offers an exciting blend of water rides, wave pools, lazy rivers, and amusement attractions. It’s an ideal place for families and children to unwind after spiritual darshan. With modern facilities, food courts, and safety standards, the park provides a refreshing contrast to Shirdi’s devotional atmosphere, making it a favorite for weekend visitors and group travelers."
  }
],

"services": [
  {
    "name": "Pune to Shirdi Innova Crysta Cab Booking",
    "description": "Book your Pune to Shirdi Innova Crysta cab effortlessly for a comfortable and reliable journey to this revered pilgrimage destination. Enjoy spacious seating, ample luggage capacity, and professional chauffeurs dedicated to providing a smooth, safe ride."
  },
  {
    "name": "One Way Innova Crysta Pune to Shirdi",
    "description": "Opt for our convenient one-way Innova Crysta taxi from Pune to Shirdi for hassle-free travel. Ideal for solo travelers, families, or groups, this service guarantees punctual pickups, air-conditioned comfort, and a relaxing drive."
  },
  {
    "name": "Round Trip Innova Crysta Pune to Shirdi",
    "description": "Plan your round trip from Pune to Shirdi with our dependable Innova Crysta cab service. Enjoy flexible scheduling and a comfortable ride with experienced chauffeurs, ensuring you have a stress-free pilgrimage or leisure trip."
  },
  {
    "name": "AC Innova Crysta Taxi Pune to Shirdi",
    "description": "Stay cool and comfortable during your Pune to Shirdi journey with our fully air-conditioned Innova Crysta taxi. Perfect for beating the heat, this service offers plush interiors and climate control for a pleasant ride."
  },
  {
    "name": "Family Innova Crysta Trip Pune to Shirdi",
    "description": "Travel with your family to Shirdi in a spacious and comfortable Innova Crysta. With ample room for passengers and luggage, our family-friendly service ensures a safe and enjoyable trip for all."
  },
  {
    "name": "Budget Innova Crysta Shirdi Cab Pune",
    "description": "Experience affordable travel with our budget-friendly Innova Crysta cab service from Pune to Shirdi. Ideal for pilgrims and travelers seeking comfort without compromising on quality and reliability."
  },
  {
    "name": "Chauffeur Driven Innova Crysta Pune to Shirdi",
    "description": "Relax and enjoy your journey as our professional chauffeurs drive you safely from Pune to Shirdi in a premium Innova Crysta. We prioritize punctuality, safety, and courteous service to enhance your travel experience."
  },
  {
    "name": "Private Innova Crysta Shirdi Taxi Pune",
    "description": "Choose our private Innova Crysta taxi service for exclusive travel between Pune and Shirdi. Perfect for VIP travelers or groups desiring privacy, with dedicated vehicles and personalized attention."
  },
  {
    "name": "Online Innova Crysta Booking Pune to Shirdi",
    "description": "Book your Pune to Shirdi Innova Crysta taxi easily online. Our secure platform offers instant confirmation, flexible timing, and transparent pricing for a seamless booking experience."
  }
],
"tableData": [
  ["Pune to Shirdi Innova Crysta Cab Booking", "One Way Innova Crysta Pune to Shirdi"],
  ["Round Trip Innova Crysta Pune to Shirdi", "AC Innova Crysta Taxi Pune to Shirdi"],
  ["Family Innova Crysta Trip Pune to Shirdi", "Budget Innova Crysta Shirdi Cab Pune"],
  ["Chauffeur Driven Innova Crysta Pune to Shirdi", "Private Innova Crysta Shirdi Taxi Pune"],
  ["Online Innova Crysta Booking Pune to Shirdi", ""]
],



"whychoose": [
    {
        "WhyChooseheading": "Comfortable Pune to Shirdi Innova Crysta Car Rental",
        "WhyChoosedescription": "Travel from Pune to Shirdi in a premium Innova Crysta for a smooth and peaceful journey to the sacred Sai Baba temple. Whether it’s a spiritual pilgrimage, family outing, or weekend getaway, we ensure a serene and comfortable ride."
    },
    {
        "WhyChooseheading": "Spacious and Luxurious Interiors for Long-Distance Travel",
        "WhyChoosedescription": "The Innova Crysta offers plush seating, excellent legroom, and air-conditioning—making your 5–6 hour journey from Pune to Shirdi truly relaxing. With space for up to 6–7 passengers and generous luggage capacity, it’s ideal for group travel."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Route Knowledge",
        "WhyChoosedescription": "Our drivers are courteous, professional, and familiar with all the best routes to Shirdi, ensuring a smooth, safe, and timely arrival. They handle highway travel confidently and are trained to assist with your needs en route."
    },
    {
        "WhyChooseheading": "Hygienic, Well-Maintained Vehicles",
        "WhyChoosedescription": "Each Innova Crysta is regularly serviced and thoroughly sanitized before your trip. You’ll enjoy a clean, odor-free, and well-functioning vehicle with all comfort features in top condition."
    },
    {
        "WhyChooseheading": "Flexible Booking Options and Custom Plans",
        "WhyChoosedescription": "Choose between one-way, same-day return, or overnight packages. You can also customize pickup time, stopovers at places like Ranjangaon or Shani Shingnapur, and drop-off points to match your travel schedule."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Costs",
        "WhyChoosedescription": "Our rental fares include fuel, tolls, taxes, and driver charges. We provide upfront pricing with no hidden fees—so you can focus on your journey without worrying about extra costs."
    },
    {
        "WhyChooseheading": "Ideal for Pilgrimage, Family Trips, and Group Travel",
        "WhyChoosedescription": "The Innova Crysta is the perfect choice for Shirdi travel, offering the right mix of comfort, space, and reliability. Whether you're going for darshan, a spiritual retreat, or a family visit, travel stress-free and in style."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Our customer support is available anytime to help with bookings, changes, or questions. You can book your Innova Crysta for Shirdi travel easily online or by phone with full assistance every step of the way."
    }
]





















    }

const faqData = [
    {
        question: "How can I book an Innova Crysta from Pune to Shirdi?",
        answer: "You can book by calling Meghana Cab at +91 9075462128 or using our website for a quick and hassle-free reservation."
    },
    {
        question: "What is the distance and travel time from Pune to Shirdi?",
        answer: "The distance is approximately 200 km, and the travel time is around 4.5 to 5.5 hours depending on traffic."
    },
    {
        question: "Is Innova Crysta suitable for long trips like Pune to Shirdi?",
        answer: "Yes, Innova Crysta is ideal for long journeys due to its spacious seating, comfort, and smooth performance."
    },
    {
        question: "Can I book the Innova Crysta for a one-way trip to Shirdi?",
        answer: "Yes, one-way and round-trip options are available as per your travel needs."
    },
    {
        question: "How many people can travel in the Innova Crysta?",
        answer: "It can comfortably accommodate 6 to 7 passengers along with luggage."
    },
    {
        question: "What is included in the Pune to Shirdi car rental fare?",
        answer: "The fare includes fuel, driver charges, and tolls. Additional waiting or parking charges may apply."
    },
    {
        question: "Are the Innova Crysta vehicles sanitized before each trip?",
        answer: "Yes, all our vehicles are cleaned and sanitized before every journey for your safety."
    },
    {
        question: "Is the service available 24/7 for Shirdi trips?",
        answer: "Yes, we operate round-the-clock to match your travel plans and darshan timings."
    },
    {
        question: "Do your drivers have experience with Shirdi routes?",
        answer: "Yes, our drivers are well-versed with Pune-Shirdi routes and ensure a smooth and safe journey."
    },
    {
        question: "What payment methods are accepted for booking?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Manoj Kale',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“We had a peaceful and comfortable journey to Shirdi in the Innova Crysta. Meghana Cab provided excellent service!”',
    },
    {
        name: 'Ms. Savita Bhosale',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Highly satisfied with the Pune to Shirdi ride. The Innova Crysta was clean and the driver was very cooperative.”',
    },
];












































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];









const puneToShirdiInnovaSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Shirdi Innova Crysta Car Rental",
  "description": "Book chauffeur-driven Innova Crysta for travel from Pune to Shirdi. Comfortable and spacious SUV ideal for family trips, pilgrimages, or group travel. Available for one-way and round trip bookings.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Outstation SUV Cab Service",
  "areaServed": {
    "@type": "City",
    "name": "Shirdi"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-shirdi-innova-crysta-cab"
  }
};







    return (
        <div>

<Helmet>
  <title>Pune to Shirdi Innova Crysta Cab | SUV Car Rental for Pilgrimage</title>
  <meta
    name="description"
    content="Book Innova Crysta cab from Pune to Shirdi for one-way or round trips. AC SUV ideal for family and group travel. Chauffeur-driven, budget-friendly car rental service."
  />
  <meta
    name="keywords"
    content="Pune to Shirdi Innova Crysta Cab Booking, One Way Innova Crysta Pune to Shirdi, Round Trip Innova Crysta Pune to Shirdi, AC Innova Crysta Taxi Pune to Shirdi, Family Innova Crysta Trip Pune to Shirdi, Budget Innova Crysta Shirdi Cab Pune, Chauffeur Driven Innova Crysta Pune to Shirdi, Private Innova Crysta Shirdi Taxi Pune, Online Innova Crysta Booking Pune to Shirdi"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToShirdiInnovaSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/46.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetoshirdiinnovacrystacarrental;